import React from 'react'
import PaymentSetupListTable from './Components/PaymentSetupListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const PaymentSetupList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Payment Setup List</HeadingOne>
          <AddItemBtn url="add-payment-setup" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <PaymentSetupListTable />
      </div>
    </PageBody>
  );
};

export default PaymentSetupList;
